import React from 'react';
import { renderToContainer, } from '../../Shared/renderToContainer';
import { destroyFns } from './destroy';
import { InternalConfirm } from './InternalConfirm';
const defaultOptions = {
    escapeKeyDownClosable: true,
    backdropClickClosable: true,
};
function confirm(config) {
    const currentConfig = {
        ...config,
        ...{ open: true },
    };
    let container = document.createDocumentFragment();
    let destroyed = false;
    const refHandler = React.createRef();
    let root = null;
    function render(renderOptions) {
        const opts = { ...defaultOptions, ...renderOptions };
        if (container) {
            root = renderToContainer(React.createElement(InternalConfirm, { ...opts, handlerRef: refHandler, withGlobalThemeProvider: true }), container);
        }
    }
    function destroy() {
        if (destroyed) {
            console.error(`Can't destroy this dialog, because this confirm dialog has been destroyed!`);
            return;
        }
        refHandler.current?.close();
        if (root) {
            root.unmount();
        }
        container = null;
        root = null;
        destroyed = true;
        for (let i = 0; i < destroyFns.length; i += 1) {
            const fn = destroyFns[i];
            /* eslint-disable-next-line */
            if (fn === destroy) {
                destroyFns.splice(i, 1);
                break;
            }
        }
        destroyed = true;
    }
    function close() {
        if (destroyed) {
            console.error(`Can't close this dialog, because this confirm dialog has been destroyed!`);
            return;
        }
        refHandler.current?.close();
    }
    function open() {
        if (destroyed) {
            console.error(`Can't open this dialog, because this confirm dialog has been destroyed!`);
            return;
        }
        refHandler.current?.open();
    }
    function update(newOptions) {
        if (destroyed) {
            console.error(`Can't update this dialog, because this confirm dialog has been destroyed!`);
            return;
        }
        refHandler.current?.update(newOptions);
    }
    destroyFns.push(destroy);
    render(currentConfig);
    return {
        destroy,
        open,
        close,
        update,
    };
}
export default confirm;
